import "../App.css";
import Navbar from "../components/Navbar";

export const Services = () => {
  return (
      <div className="App">
        <Navbar />
      </div>
  );
}

export default Services;